import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useCreditUsageSubscription } from 'hooks/useCreditUsageSubscription'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useRef } from 'react'
import { useRootStore } from 'stores/RootStore'

export const CreditUsageListener = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const creditUsageStore = useRootStore().creditUsageStore
  const prevWorkspaceIdRef = useRef(workspaceId)

  useEffect(() => {
    if (prevWorkspaceIdRef.current !== workspaceId) {
      creditUsageStore.reset()
      prevWorkspaceIdRef.current = workspaceId
    }

    creditUsageStore.fetchedWorkspaceId = workspaceId
    creditUsageStore.fetch(workspaceId)
  }, [creditUsageStore, workspaceId])

  const handleCreditUsageUpdate = useCallback(
    (creditUsage: Parameters<typeof creditUsageStore.setCreditUsage>[0]) => {
      if (creditUsageStore.fetchedWorkspaceId === workspaceId) {
        creditUsageStore.setCreditUsage(creditUsage)
      }
    },
    [creditUsageStore, workspaceId],
  )

  useCreditUsageSubscription({
    workspaceId,
    onUpdate: handleCreditUsageUpdate,
  })

  return null
})
